import styles from "./TransactionDetail.module.scss";
import TimelineItem from "./TimelineItem";
import { TimelineEntry } from "./timeline";

interface TransactionTimelineProps {
	entries?: TimelineEntry[];
}

const TransactionTimeline = ({ entries }: TransactionTimelineProps) => {
	return (
		<div className={styles.timelineList}>
			{(entries ?? []).map(entry => (
				<TimelineItem key={entry.id} entry={entry} />
			))}
		</div>
	);
};

export default TransactionTimeline;
